import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="px-6 md:px-12 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8">
          <div>
            <Link
              to="/"
              className="flex items-center gap-2 text-background-50 hover:text-primary-300 transition-colors cursor-pointer"
            >
              <i className="ri-database-2-line text-2xl w-6 h-6 flex items-center justify-center"></i>
              <span className="font-heading text-xl font-bold">OOPBuy Spreadsheet</span>
            </Link>
            <p className="mt-4 text-sm text-foreground-300 leading-relaxed max-w-xs">
              Your smart bridge to curated product sourcing. Structured data, verified suppliers, and 14 live categories — all accessible through one powerful spreadsheet system.
            </p>
            <div className="flex items-center gap-3 mt-5">
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="w-9 h-9 rounded-full border border-foreground-500 flex items-center justify-center text-foreground-400 hover:text-primary-300 hover:border-primary-400 transition-colors cursor-pointer"
              >
                <i className="ri-global-line text-sm w-4 h-4 flex items-center justify-center"></i>
              </a>
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="w-9 h-9 rounded-full border border-foreground-500 flex items-center justify-center text-foreground-400 hover:text-primary-300 hover:border-primary-400 transition-colors cursor-pointer"
              >
                <i className="ri-shopping-bag-3-line text-sm w-4 h-4 flex items-center justify-center"></i>
              </a>
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="w-9 h-9 rounded-full border border-foreground-500 flex items-center justify-center text-foreground-400 hover:text-primary-300 hover:border-primary-400 transition-colors cursor-pointer"
              >
                <i className="ri-store-2-line text-sm w-4 h-4 flex items-center justify-center"></i>
              </a>
            </div>
          </div>

          <div className="flex flex-col gap-6">
            <div>
              <p className="text-xs font-semibold text-foreground-500 uppercase tracking-wider mb-2">Quick Links</p>
              <div className="flex flex-col gap-2">
                <Link to="/" className="text-sm text-foreground-300 hover:text-primary-300 transition-colors cursor-pointer">Home</Link>
                <Link to="/article/oopbuy-spreadsheet-beginners-guide" className="text-sm text-foreground-300 hover:text-primary-300 transition-colors cursor-pointer">Shopping Guide</Link>
                <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-300 hover:text-primary-300 transition-colors cursor-pointer">Full Catalog</a>
              </div>
            </div>
            <div>
              <p className="text-xs font-semibold text-foreground-500 uppercase tracking-wider mb-2">Featured Categories</p>
              <div className="grid grid-cols-2 gap-x-4 gap-y-1.5">
                <a href="https://kaspreadsheet.com/category-911-Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-300 hover:text-primary-300 transition-colors cursor-pointer">Shoes</a>
                <a href="https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-300 hover:text-primary-300 transition-colors cursor-pointer">Hoodies/Sweaters</a>
                <a href="https://kaspreadsheet.com/category-913-T-Shirts.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-300 hover:text-primary-300 transition-colors cursor-pointer">T-Shirts</a>
                <a href="https://kaspreadsheet.com/category-914-Jackets.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-300 hover:text-primary-300 transition-colors cursor-pointer">Jackets</a>
                <a href="https://kaspreadsheet.com/category-920-Accessories.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-300 hover:text-primary-300 transition-colors cursor-pointer">Accessories</a>
                <a href="https://kaspreadsheet.com/category-921-Bags.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-300 hover:text-primary-300 transition-colors cursor-pointer">Bags</a>
              </div>
            </div>
          </div>

          <div className="flex flex-col gap-6">
            <div>
              <p className="text-xs font-semibold text-foreground-500 uppercase tracking-wider mb-2">Contact</p>
              <p className="text-sm text-foreground-300 leading-relaxed">
                Visit our main catalog at<br />
                <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="text-primary-300 hover:text-primary-200 transition-colors cursor-pointer">
                  kaspreadsheet.com
                </a>
              </p>
            </div>
            <div>
              <p className="text-xs font-semibold text-foreground-500 uppercase tracking-wider mb-2">About</p>
              <p className="text-sm text-foreground-300 leading-relaxed">
                OOPBuy Spreadsheet is a structured product tracking system built for e-commerce sellers who need verified supplier data across 14 curated categories.
              </p>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} OOPBuy Spreadsheet. All rights reserved.
          </p>
          <div className="flex items-center gap-5">
            <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors cursor-pointer">
              Main Site
            </a>
            <Link to="/article/oopbuy-spreadsheet-beginners-guide" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors cursor-pointer">
              Shopping Guide
            </Link>
            <Link to="/" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors cursor-pointer">
              Home
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}